// src/api/serviceApi.js
import { axiosConfig } from "./axiosClient";

export const fetchServices = async () => {
  try {
    const response = await axiosConfig.get("/service"); // endpoint à adapter
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des services:", error);
    return [];
  }
};

// Tu peux ajouter d'autres fonctions ici :
export const getServiceById = async (id) => {
    try {
      const response = await axiosConfig.get(`/service/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération du service ${id}:`, error);
        return null;
    }
};
